import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import CustomHeader from './CustomHeader';
import CustomDrawerHeader from './CustomDrawerHeader';
import { menu_config } from '../config/menu.config';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { Breadcrumbs, Grid } from '@mui/material';
import { paths } from '../config/router.config';
import { makeStyles } from '@mui/styles';
import { common } from '@mui/material/colors';
import wsclients from '../services/wsclients';
import { portalCfg } from '../config';

const defaultImage = portalCfg.publicPath + "/images/logo.png";
const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    color: theme.palette.common.white,
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    // width: `calc(${theme.spacing(7)} + 1px)`,
    width: 0,
    [theme.breakpoints.up('lg')]: {
        width: `calc(${theme.spacing(9)} + 1px)`,
    },
    color: theme.palette.common.white,
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const useStyles = makeStyles((theme) => ({
    drawerPaper: {
        background: theme.palette.primary.main + '!important',
        borderRight: 'none' + '!important',
    },
    icon_color: {
        color: theme.palette.common.white,
    },
    box_icon: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        backgroundColor: theme.palette.common.white,
        textAlign: 'center',
        borderRadius: theme.spacing(4),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    icon_menu: {
        marginTop: theme.spacing(0.9),
    },
    hr_color: {
        color: theme.palette.common.white,
        borderColor: theme.palette.common.white + '!important',
    },
    icon_logo: {
        width: '100%',
        height: theme.spacing(6),
        objectFit: 'contain',
    },
    icon_logo_small: {
        width: '100%',
        height: theme.spacing(3),
        objectFit: 'contain',
    },
    active_menu: {
        background: theme.palette.primary.dark + '!important',
        borderLeft: '4px solid #fff!important',
    },
    text_over: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: theme.spacing(0, 2)
    },
}))

export default function CustomMenu(props) {
    const classes = useStyles();
    let history = useHistory();

    const { open, handleDrawer } = props;

    const [menuSelected, setMenuSelected] = React.useState(null);
    const [titleHeader, setTitleHeader] = React.useState(null);
    const [openDrawer, setOpenDrawer] = React.useState({});

    const profileName = wsclients.getSession();
    // console.log("profileName==", profileName);

    React.useEffect(() => {
        let pathname = window.location.pathname;
        console.log("pathname ====", pathname);
        setMenuSelected(mapMenuId(pathname));
    }, []);

    const onClickMenu = (menu, is_sub_menu) => {
        setMenuSelected(menu.id);
        if(window.innerWidth <= 768){
            handleDrawer(false)
        }
        history.push(menu.route);
    }
    const onClickSubMenu = (sub_menu) => {
        switch (sub_menu.id) {
            case 'menu_rewards_qr_code':
            case 'menu_get_smiles':
            case 'menu_shop_2u':
            case 'menu_convert_smile':
                setOpenDrawer({
                    ...openDrawer,
                    [sub_menu.id]: true,
                });
                break;
            default:
                if (sub_menu.route) {
                    history.push(sub_menu.route)
                }
                setTitleHeader(sub_menu.title)
        }
    }
    console.log("menuSelected ====", menuSelected);
    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <CustomHeader title={titleHeader} open={open} handleDrawer={handleDrawer} setTitleHeader={setTitleHeader} setMenuSelected={setMenuSelected} />
            <Drawer anchor="left" variant="permanent" open={open} classes={{ paper: classes.drawerPaper }}>
                <CustomDrawerHeader>
                    <img src={defaultImage} alt="Logo" className={open ? classes.icon_logo : classes.icon_logo_small} />
                </CustomDrawerHeader>
                <DrawerItem
                    open={open}
                    onClickMenu={onClickMenu}
                    onClickSubMenu={onClickSubMenu}
                    menuSelected={menuSelected}
                    contactName={profileName && profileName.preferred_username ? profileName.preferred_username : ""}
                />
            </Drawer>
        </Box>
    );
}

function mapMenuId(string) {
    let menuId = '';
    if (string === paths.setting) {
        menuId = 'menu_setting'
    } else if (string === paths.support || string === paths.support_add) {
        menuId = 'menu_support'
    } else if (string === paths.bills || string === paths.bill_detail) {
        menuId = 'menu_bills'
    } else if (string === paths.subcriptions || string === paths.swap_service) {
        menuId = 'menu_subcriptions'
    } else if (string === paths.notifications) {
        menuId = null;
    } else if(string === paths.home){
        menuId = 'menu_home';
    } else if(string === paths.invoices){
        menuId = 'menu_invoices'
    }
    else if (!string) {
        menuId = 'menu_home';
    }
    return menuId;
}

function DrawerItem(props) {
    const theme = useTheme();
    const classes = useStyles();
    const { t } = useTranslation();
    const { onClickMenu, onClickSubMenu, menuSelected, open, contactName } = props;
    let pathname = window.location.pathname;
    if(pathname === '' || pathname === '/home') pathname = '/home';
    let menu_selected = mapMenuId(pathname);
    return (
        <Grid xs={12} item>
            {open && <Grid xs={12} item container justifyContent={'center'} marginBottom={3}>
                <Typography variant="subtitle1" color={common.white} className={classes.text_over}>{contactName}</Typography>
            </Grid>}
            <List>
                {menu_config.map((menu, index) => (
                    <div key={index}>
                        {menu.showMenu &&
                            <ListItem button key={index} title={t(menu.title)}
                                onClick={() => onClickMenu(menu, menu && menu.sub_menu ? true : false)}
                                className={menu.id === menu_selected ? classes.active_menu : null}
                            >
                                <ListItemIcon>
                                    <Box className={classes.box_icon}>
                                        {menu.icon}
                                    </Box>
                                </ListItemIcon>
                                <Typography variant="subtitle2" color={common.white}>{t(menu.title)}</Typography>
                            </ListItem>}
                        {menu.sub_menu && menuSelected === menu.id &&
                            <List style={{ marginLeft: theme.spacing(1) }}>
                                {menu.sub_menu.map((sub_menu, sub_index) => (
                                    <div key={sub_index}>
                                        {sub_menu.showMenu &&
                                            <ListItem button title={t(sub_menu.title)} onClick={() => onClickSubMenu(sub_menu)}>
                                                <ListItemIcon>
                                                    <Box className={classes.box_icon}>
                                                        {sub_menu.icon}
                                                    </Box>
                                                </ListItemIcon>
                                                <Typography variant="caption" color={common.white}>{t(sub_menu.title)}</Typography>
                                            </ListItem>
                                        }
                                    </div>
                                ))}
                            </List>}
                    </div>
                ))}
            </List>
        </Grid>
    )
}
